import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { selectIsSmallScreen, selectWindowType, WindowTypes } from 'store/pageStore';
import { checkScreenType, prepareCategoryData } from 'utils';
import { CardType } from '../types';
import { useCardClickAnalytics } from './use-card-click-analytics';

export const useCategoryCard = (categoryData, cardType, onClickHandler) => {
	const isSmallScreen = useSelector(selectIsSmallScreen);
	const currentWindowType = useSelector(selectWindowType);

	const isMobile = checkScreenType(currentWindowType, WindowTypes.mobile);

	const isPopularOrderCard = cardType === CardType.popularOrder;
	const isCatalogueOrderCard = cardType === CardType.catalogueOrder;
	const isPopularCard = cardType === CardType.popular;
	const isOrderCard = isPopularOrderCard || isCatalogueOrderCard;

	const preparedCategoryData = prepareCategoryData(categoryData);

	const { ref, analyticsClickHandler } = useCardClickAnalytics({
		categoryData,
		isPopularCard,
		isPopularOrderCard,
		isCatalogueOrderCard,
	});

	const onClick = useCallback(
		(event: React.MouseEvent<HTMLElement>) => {
			analyticsClickHandler(event);
			onClickHandler(preparedCategoryData);
		},
		[onClickHandler, analyticsClickHandler, preparedCategoryData]
	);

	return {
		isSmallScreen,
		isMobile,
		isPopularCard,
		isPopularOrderCard,
		isCatalogueOrderCard,
		isOrderCard,
		preparedCategoryData,
		onClick,
		ref,
	};
};
